module.exports = __webpack_public_path__ + "img/6.f6c77cbe.png";